export const size = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopM: 1216,
  laptopL: 1440,
  desktop: 2560,
}

export const device = {
  mobileS: `(min-width: ${size.mobileS}px)`,
  mobileM: `(min-width: ${size.mobileM}px)`,
  mobileL: `(min-width: ${size.mobileL}px)`,
  tablet: `(min-width: ${size.tablet}px)`,
  laptop: `(min-width: ${size.laptop}px)`,
  laptopM: `(min-width: ${size.laptopM}px)`,
  laptopL: `(min-width: ${size.laptopL}px)`,
  desktop: `(min-width: ${size.desktop}px)`,

  toTablet: `(max-width: ${size.tablet - 1}px)`,
  toLaptopL: `(max-width: ${size.laptopL - 1}px)`,
  fromTabletTolaptop: `(min-width: ${size.tablet}px) and (max-width: ${
    size.laptop - 1
  }px)`,
  fromTabletTolaptopL: `(min-width: ${size.tablet}px) and (max-width: ${
    size.laptopL - 1
  }px)`,
  fromLaptopTolaptopL: `(min-width: ${size.laptop}px) and (max-width: ${
    size.laptopL - 1
  }px)`,
}

export const AVAILABLE_DEVICE = {
  mobile: {
    min: 0,
    max: 767,
  },
  tablet: {
    min: 768,
    max: 1024,
  },
  laptop: {
    min: 1025,
    max: 1439,
  },
  desktop: {
    min: 1440,
    max: 2559,
  },
  desktopL: 2560,
}

export const DESKTOP = 'desktop'
export const LAPTOP = 'laptop'
export const TABLET = 'tablet'
export const MOBILE = 'mobile'
